(function () {
  if (window.__cartSizeSelect) return;
  window.__cartSizeSelect = true;

  var productCache = {};
  var busy = false;
  var timer = null;

  var ROOTS = '#CartDrawer [data-products], [data-section-type="cart-template"], main form[action="/cart"]';
  var QTY_SEL = '.js-qty__wrapper, .js-qty, [data-qty-wrapper]';

  var TRASH_SVG =
    '<svg class="cart-trash-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" ' +
    'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';

  var style = document.createElement('style');
  style.textContent =
    '.cart-controls-row{display:flex;align-items:center;gap:12px;flex-wrap:wrap;margin:10px 0}' +
    '.cart-controls-row .cart-size-box{margin:0}' +
    '.cart-size-box{display:inline-flex;align-items:center;gap:12px;border:1px solid #e0e0e0;' +
    'border-radius:4px;padding:10px 14px;margin:10px 0;background:#fff;font-size:14px;line-height:1}' +
    '.cart-size-box__label{font-weight:700;color:#222}' +
    '.cart-size-select{border:0;outline:0;background:transparent;font-size:14px;color:#222;' +
    'cursor:pointer;padding:0 4px;margin:0;box-shadow:none;width:auto;min-width:50px}' +
    '.cart-size-select:disabled{opacity:.5}';
  document.head.appendChild(style);

  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); });
    }
    return productCache[handle];
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function findSizeIndex(product) {
    for (var i = 0; i < product.options.length; i++) {
      var name = product.options[i].name || product.options[i];
      if (/size/i.test(name)) return i;
    }
    return product.options.length === 1 ? 0 : -1;
  }

  function refreshDrawer(oldSelect) {
    try {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (window.jQuery) jQuery('body').trigger('ajaxProduct:added');
    } catch (e) {}

    // If the old dropdown is still in the page after a moment, the theme did not rebuild, so reload
    return new Promise(function (resolve) {
      setTimeout(function () {
        if (document.body.contains(oldSelect)) {
          if (document.querySelector('#CartDrawer.is-open, #CartDrawer.js-drawer-open, html.js-drawer-open')) {
            sessionStorage.setItem('reopenCartDrawer', '1');
          }
          window.location.reload();
        }
        resolve();
      }, 900);
    });
  }

  function build(container, item, product) {
    var sizeIdx = findSizeIndex(product);
    if (sizeIdx === -1) return;

    var current = product.variants.filter(function (v) { return v.id === item.variant_id; })[0];
    if (!current) return;
    var optKey = 'option' + (sizeIdx + 1);

    var sizes = [];
    product.variants.forEach(function (v) {
      var sameOthers = [1, 2, 3].every(function (n) {
        return (n - 1) === sizeIdx || v['option' + n] === current['option' + n];
      });
      if (sameOthers) sizes.push(v);
    });
    var availableCount = sizes.filter(function (v) { return v.available || v.id === item.variant_id; }).length;
    if (availableCount < 2) return;

    var sel = document.createElement('select');
    sel.className = 'cart-size-select';
    sel.setAttribute('aria-label', 'Change size');

      sizes.forEach(function (v) {
      // skip sold-out sizes (always keep the size currently in the cart)
      if (!v.available && v.id !== item.variant_id) return;
      var o = document.createElement('option');
      o.value = v.id;
      o.textContent = v[optKey] + (v.available ? '' : ' (sold out)');
      o.selected = v.id === item.variant_id;
      sel.appendChild(o);
    });

    sel.addEventListener('change', function () {
      var newId = parseInt(sel.value, 10);
      if (newId === item.variant_id) return;
      busy = true;
      sel.disabled = true;

      post('/cart/add.js', {
        items: [{ id: newId, quantity: item.quantity, properties: item.properties || {} }]
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return post('/cart/change.js', { id: item.key, quantity: 0 });
        })
              .then(function () {
          return refreshDrawer(sel);
        })
        .then(function () {
          busy = false;
        })
        .catch(function () {
          busy = false;
          sel.disabled = false;
          sel.value = item.variant_id;
          alert('Sorry, this size could not be added. Please try another size.');
        });
    });

    container.setAttribute('data-size-select', '1');

    var box = document.createElement('div');
    box.className = 'cart-size-box';
    var label = document.createElement('span');
    label.className = 'cart-size-box__label';
    label.textContent = 'Size';
    box.appendChild(label);
    box.appendChild(sel);

    var qty = container.querySelector(QTY_SEL);
    if (qty && qty.parentNode) {
      // put quantity + size side by side in one row
      var row = document.createElement('div');
      row.className = 'cart-controls-row';
      qty.parentNode.insertBefore(row, qty);
      row.appendChild(qty);
      row.appendChild(box);
    } else {
      var link = container.querySelector('a[href*="/products/"]');
      var anchor = link && link.parentElement ? link.parentElement : container;
      anchor.appendChild(box);
    }
  }

  // show a trash icon instead of "-" when quantity is 1
  function styleQty() {
    document.querySelectorAll(QTY_SEL).forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var minus = wrap.querySelector('.js-qty__adjust--minus, [data-action="minus"], button:first-of-type');
      if (!input || !minus) return;

      var isOne = parseInt(input.value, 10) === 1;
      var state = isOne ? 'trash' : 'minus';
      if (minus.getAttribute('data-qty-state') === state) return; // no change = no loop

      if (!minus.hasAttribute('data-minus-html')) {
        minus.setAttribute('data-minus-html', minus.innerHTML);
      }
      minus.innerHTML = isOne ? TRASH_SVG : minus.getAttribute('data-minus-html');
      minus.setAttribute('data-qty-state', state);
    });
  }

  function enhance() {
    styleQty();
    if (busy) return;
    var roots = document.querySelectorAll(ROOTS);
    if (!roots.length) return;

    fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var counters = {};
        var seen = [];

        roots.forEach(function (root) {
          root.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
            var container = link.closest('[data-cart-item], .cart__item, .cart__row, tr, li') || link.parentElement;
            if (!container || seen.indexOf(container) !== -1) return;
            seen.push(container);

            var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
            if (!m) return;
            var handle = m[1];

            var vm = link.getAttribute('href').match(/variant=(\d+)/);
            var item;
            if (vm) {
              item = cart.items.filter(function (i) { return i.variant_id === parseInt(vm[1], 10); })[0];
            }
            if (!item) {
              var list = cart.items.filter(function (i) { return i.handle === handle; });
              var key = root === roots[0] ? 'a' + handle : 'b' + handle;
              counters[key] = counters[key] || 0;
              item = list[counters[key]++];
            }
            if (!item || container.getAttribute('data-size-select')) return;

            getProduct(handle).then(function (product) {
              if (!container.getAttribute('data-size-select')) build(container, item, product);
            });
          });
        });
      })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(enhance, 200);
  }

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', schedule);
  document.addEventListener('change', schedule);

  window.addEventListener('load', function () {
    if (sessionStorage.getItem('reopenCartDrawer')) {
      sessionStorage.removeItem('reopenCartDrawer');
      setTimeout(function () {
        var btn = document.querySelector('.js-drawer-open-cart');
        if (btn) btn.click();
      }, 400);
    }
    schedule();
  });
})();